import loadable from "@loadable/component";

export default loadable(() => import(/* webpackChunkName: "initializer_old" */ "./Loadable"));
